<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/collections/collections.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :exportCsv="exportCsv"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Cobranza', plural:'Cobranzas'}"
      :key="moduleName"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useCollectionsStore } from '@/store/collections';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/collections/collections.config';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Collections';
const preferencesStore = usePreferencesStore();
const collectionsStore = useCollectionsStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => collectionsStore.fetchCollections(params),
  {
    create: collectionsStore.createCollection,
    update: (data) => collectionsStore.updateCollection(data.id, data),
    remove: collectionsStore.deleteCollection,
    exportCsv: () => Promise.resolve()
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => collectionsStore.collections);
</script>
